<template>
  <div>
    <strong>Deleted {{ retentionType }}(s)</strong><br>
    <span v-for="(deleted, index) in rowProperties.attributes" :key="`deleted-${index}`"
          class="kt-font-danger">
      <i class="fa fa-minus-circle" />{{ deleted.name }} ({{ deleted.uuid }})<br>
    </span>
    <strong>Deleted Related {{ related_type }}(s)</strong>
    <span v-for="(related, index) in related_assets" :key="`related-${index}`">
      <span v-if="related && related.name"
            class="kt-font-danger">
        <i class="fa fa-minus-circle" />{{ related.name }} ({{ related.uuid }})<br>
      </span>
      <span v-else>N/A</span>
    </span>
  </div>
</template>

<script>
import PropertiesMixin from "VueMixins/ActivityLog/PropertiesMixin";

export default {
  mixins: [PropertiesMixin],
  props: {
    rowProperties: {
      type: Object,
      required: true,
    },
    retentionType: {
      type: String,
      required: false,
      default: 'storage',
    },
  },
  computed: {
    related_assets() {
      return _.map(this.rowProperties.attributes, attribute => attribute.relation);
    },
    related_type() {
      if (this.retentionType === 'storage') {
        return 'item';
      }

      return 'storage asset';
    },
  },
};
</script>
